<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 100px"
    stateless
  >
    <v-form
      ref="form"
      lazy-validation
      class="d-flex flex-column"
      style="height: calc(100% - 100px)"
    >
      <v-toolbar flat dark color="primary">
        <v-list-item class="px-0" v-if="formAction === 'add'">
          <v-list-item-icon>
            <v-icon>mdi-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-title>เพิ่มสถานที่</v-list-item-title>
        </v-list-item>
        <v-list-item class="px-0" two-line v-else>
          <v-list-item-content>
            <v-list-item-title>
              <span v-if="companyLocationInit.company_location_code">
                {{ companyLocationInit.company_location_code }} -
              </span>
              <span>
                {{ companyLocationInit.title_th }}
              </span>
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ companyLocationInit.title_en }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-spacer></v-spacer>

        <v-btn icon @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div class="pa-5" style="height: 100%; overflow: auto">
        <label class="body-2">รหัสสถานที่</label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="1"
          v-model="companyLocation.company_location_code"
          clearable
          @change="checkEmpty($event, 'company_location_code')"
          outlined
          dense
        ></v-text-field>
        <label class="body-2">
          ชื่อสถานที่
          <span class="red--text"><strong>*</strong></span>
        </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="2"
          v-model="companyLocation.title_th"
          :rules="[(v) => !!v || 'โปรดระบุชื่อสถานที่']"
          required
          clearable
          @change="checkEmpty($event, 'title_th')"
          outlined
          dense
        >
        </v-text-field>
        <label class="body-2">สถานที่ (อังกฤษ)</label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="3"
          v-model="companyLocation.title_en"
          clearable
          @change="checkEmpty($event, 'title_en')"
          outlined
          dense
        ></v-text-field>
        <div class="mt-4">
          <label class="body-2">
            ประเภทสถานที่
            <span class="red--text"><strong>*</strong></span>
          </label>
          <v-autocomplete
            class="fix-google-chrome mt-1"
            tabindex="4"
            v-model="companyLocation.location_type"
            :items="locationTypes"
            :rules="[(v) => !!v || 'โปรดระบุประเภทสถานที่']"
            item-text="title_th"
            item-value="location_type_code"
            outlined
            dense
            return-object
          >
          </v-autocomplete>
        </div>
        <label class="body-2">
          ละติจูด
          <span class="red--text"><strong>*</strong></span>
        </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="5"
          v-model="companyLocation.latitude"
          :rules="[
            (v) => !!v || 'โปรดระบุละติจูด',
            (v) => /^-?[0-9]*\.?[0-9]*$/.test(v) || 'ละติจูดต้องเป็นตัวเลข',
            (v) => (v >= -90 && v <= 90) || 'ละติจูดต้องอยู่ระหว่าง -90 ถึง 90',
          ]"
          required
          clearable
          @click:clear="$store.commit('googleMap/SET_MARKERS', [])"
          @change="checkEmpty($event, 'latitude')"
          outlined
          dense
        >
        </v-text-field>
        <label class="body-2">
          ลองจิจูด
          <span class="red--text"><strong>*</strong></span>
        </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="6"
          v-model="companyLocation.longitude"
          :rules="[
            (v) => !!v || 'โปรดระบุลองจิจูด',
            (v) => /^-?[0-9]*\.?[0-9]*$/.test(v) || 'ลองจิจูดต้องเป็นตัวเลข',
            (v) =>
              (v >= -180 && v <= 180) || 'ลองจิจูดต้องอยู่ระหว่าง -180 ถึง 180',
          ]"
          required
          clearable
          @click:clear="$store.commit('googleMap/SET_MARKERS', [])"
          @change="checkEmpty($event, 'longitude')"
          outlined
          dense
        >
        </v-text-field>
        <a v-if="appMode === 'private'" :href="googleMapsUrl" target="_blank">
          Google Maps
        </a>
        <v-btn
          v-else
          outlined
          color="error"
          @click="onOpenLocationGoogleMapDialog"
        >
          <v-icon>mdi-map-marker</v-icon>
        </v-btn>
        <div class="mt-4">
          <label class="body-2">
            รัศมี (เมตร)
            <span class="red--text"><strong>*</strong></span>
          </label>
          <v-text-field
            class="fix-google-chrome mt-1"
            tabindex="7"
            v-model="companyLocation.radius_meter"
            :rules="[
              (v) => !!v || 'โปรดระบุรัศมี (เมตร)',
              (v) => /^\d+$/.test(v) || 'รัศมีต้องเป็นตัวเลขจำนวนเต็ม',
            ]"
            required
            clearable
            @change="checkEmpty($event, 'radius_meter')"
            outlined
            dense
          >
          </v-text-field>
        </div>
        <!-- <label class="body-2">Timezone</label>
        <v-autocomplete
          class="fix-google-chrome mt-1"
          tabindex="8"
          v-model="companyLocation.timezone"
          :items="timezone"
          :rules="[(v) => !!v || 'โปรดระบุ Timezone']"
          item-text="text"
          item-value="adjustment"
          outlined
          dense
        ></v-autocomplete> -->
      </div>
      <v-toolbar flat color="blue-grey lighten-4">
        <v-row
          justify="center"
          align="center"
          v-if="!isCompanyLocationDataChange && formAction === 'edit'"
        >
          <v-btn
            :disabled="
              uiCtrl && !uiCtrl.isEnable('btn:::company_location:delete')
            "
            icon
            @click="onDelete"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-row>
        <v-row justify="center" align="center" v-else>
          <v-btn
            :disabled="
              uiCtrl && !uiCtrl.isEnable('btn:::company_location:create')
            "
            tabindex="9"
            class="primary mr-3"
            depressed
            v-if="formAction === 'add'"
            @click="onSubmit"
            >ตกลง
          </v-btn>
          <v-btn
            :disabled="
              uiCtrl && !uiCtrl.isEnable('btn:::company_location:update')
            "
            tabindex="9"
            class="primary mr-3"
            depressed
            v-else
            @click="onSave"
            >บันทึก
          </v-btn>
          <v-btn depressed @click="onReset">ยกเลิก</v-btn>
        </v-row>
      </v-toolbar>
    </v-form>
    <ConfirmDialog
      :dialog="confirmDialogDelete"
      :loading="confirmDialogDeleteLoading"
      :dialogData="confirmDialogDeleteData"
      @cancelConfirmDialog="cancelConfirmDialogDelete"
      @submitConfirmDialog="submitConfirmDialogDelete"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <GoogleMap
      :dialog="googleMapDialog"
      @onSubmit="onSubmitLocationGoogleMapDialog"
      @onCancel="onCancelLocationGoogleMapDialog"
    />
  </v-navigation-drawer>
</template>

<script>
import tzlookup from 'tz-lookup'
// import axios from 'axios'
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import GoogleMap from '@/components/GoogleMap.vue'

// import static data
import timezone from '@/data/timezone.json'

export default {
  components: {
    ConfirmDialog,
    GoogleMap,
  },
  props: {
    formShow: {
      type: Boolean,
      default: false,
    },
    formAction: {
      type: String,
      default: '',
    },
    companyLocation: {
      type: Object,
    },
    companyLocationInit: {
      type: Object,
    },
  },
  data() {
    return {
      googleMapsUrl: 'https://maps.google.com',
      appMode: process.env.VUE_APP_MODE,
      googleMapDialog: false,
      confirmDialogDelete: false,
      confirmDialogDeleteLoading: false,
      confirmDialogDeleteData: {},
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      timezone: timezone,
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    locationGoogleMap() {
      return this.markers.length > 0
        ? `${this.markers[0].position.lat.toFixed(
            5
          )}, ${this.markers[0].position.lng.toFixed(5)}`
        : ''
    },
    locationTypes() {
      return this.$store.state.locationType.locationTypes
    },
    markers() {
      return this.$store.state.googleMap.markers
    },
    markersInit() {
      return this.$store.state.googleMap.markersInit
    },
    isCompanyLocationDataChange() {
      if (
        JSON.stringify(this.markers) !== JSON.stringify(this.markersInit) ||
        this.companyLocation.company_location_code !==
          this.companyLocationInit.company_location_code ||
        this.companyLocation.title_th !== this.companyLocationInit.title_th ||
        this.companyLocation.title_en !== this.companyLocationInit.title_en ||
        this.companyLocation.location_type?.location_type_code !==
          this.companyLocationInit.location_type?.location_type_code ||
        this.companyLocation.latitude !== this.companyLocationInit.latitude ||
        this.companyLocation.longitude !== this.companyLocationInit.longitude ||
        this.companyLocation.radius_meter !==
          this.companyLocationInit.radius_meter ||
        this.companyLocation.timezone !== this.companyLocationInit.timezone
      ) {
        this.$emit('isCompanyLocationDataChange', true)
        return true
      }
      this.$emit('isCompanyLocationDataChange', false)
      return false
    },
  },
  methods: {
    ...mapActions({
      addCompanyLocation: 'companyLocation/addCompanyLocation',
      editCompanyLocation: 'companyLocation/editCompanyLocation',
      deleteCompanyLocation: 'companyLocation/deleteCompanyLocation',
    }),
    onOpenLocationGoogleMapDialog() {
      if (this.companyLocation.latitude && this.companyLocation.longitude) {
        const markers = []
        const latLng = {
          lat: parseFloat(this.companyLocation.latitude),
          lng: parseFloat(this.companyLocation.longitude),
        }
        markers.push({ position: latLng })
        this.$store.commit('googleMap/SET_MAP_CENTER', latLng)
        this.$store.commit('googleMap/SET_MARKERS', markers)
      }
      this.googleMapDialog = true
    },
    onSubmitLocationGoogleMapDialog() {
      if (this.locationGoogleMap) {
        const location = this.locationGoogleMap.split(', ')
        const lat = location[0]
        const lng = location[1]

        this.companyLocation.latitude = lat
        this.companyLocation.longitude = lng

        // // Current date/time of user computer
        // const currentDate = new Date()
        // // Current UTC date/time expressed as seconds since midnight, January 1, 1970 UTC
        // const timestamp =
        //   currentDate.getTime() / 1000 + currentDate.getTimezoneOffset() * 60

        // axios
        //   .get(
        //     `https://maps.googleapis.com/maps/api/timezone/json?location=${lat},${lng}&timestamp=${timestamp}&key=${process.env.VUE_APP_GOOGLE_MAP_API_KEY_CLIENT}`
        //   )
        //   .then((res) => {
        //     const result = res.data
        //     if (result.status !== 'ZERO_RESULTS') {
        //       const timezone = this.getTzString(result.rawOffset)
        //       const locationTimezone = this.timezone.find(
        //         (tz) => tz.adjustment === timezone
        //       )
        //       this.companyLocation.timezone = locationTimezone.adjustment
        //     }
        //     this.googleMapDialog = false
        //   })

        this.googleMapDialog = false
      } else {
        this.googleMapDialog = false
      }
    },
    getOffsetStr(timeZone) {
      const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone,
        timeZoneName: 'longOffset',
      })

      const parts = formatter.formatToParts(new Date())
      const tzPart = parts.find((part) => part.type === 'timeZoneName')

      return tzPart ? tzPart.value.replace('GMT', '') : '+00:00'
    },
    onCancelLocationGoogleMapDialog() {
      if (this.formAction === 'add') {
        this.$store.commit('googleMap/SET_MARKERS', [])

        this.companyLocation.latitude = ''
        this.companyLocation.longitude = ''
      } else {
        // this.$emit('onReset', this.formAction)
        const markers = []
        const latLng = {
          lat: parseFloat(this.companyLocationInit.latitude),
          lng: parseFloat(this.companyLocationInit.longitude),
        }
        markers.push({ position: latLng })
        this.$store.commit('googleMap/SET_MAP_CENTER', latLng)
        this.$store.commit('googleMap/SET_MARKERS', markers)
        this.companyLocation.latitude = this.companyLocationInit.latitude
        this.companyLocation.longitude = this.companyLocationInit.longitude
      }
      this.googleMapDialog = false
    },
    getTzString(offset) {
      const secInHour = 3600
      const secInMin = 60

      let isNagativeOffset = offset < 0
      let positiveOffset = Math.abs(offset)

      // hour
      let h = '' + Math.floor(positiveOffset / secInHour)
      while (h.length < 2) {
        h = '0' + h
      }
      if (isNagativeOffset) {
        h = '-' + h
      } else {
        h = '+' + h
      }

      // minute
      let m = ((positiveOffset % secInHour) / secInHour) * secInMin

      return `${h}:${m === 0 ? '00' : m}`
    },
    checkEmpty(value, field) {
      if (value) {
        this.companyLocation[field] = value.trim()
      }
    },
    onDelete() {
      this.confirmDialogDelete = true
      this.confirmDialogDeleteData = {
        title: 'ยืนยันการลบ',
        text: 'การลบสถานที่นี้จะส่งผลต่อสถานที่ที่เคยเพิ่มให้กับพนักงาน และอาจทำให้พนักงานไม่สามารถลงเวลาที่สถานที่นี้ได้อีก หากต้องการลบจริง โปรดพิมพ์ delete',
        value: this.companyLocation.title_th,
        requireText: 'delete',
        item: this.companyLocation,
      }
    },
    cancelConfirmDialogDelete() {
      this.confirmDialogDelete = false
    },
    submitConfirmDialogDelete(companyLocation) {
      const { company_uuid } = this.$store.state.authentication.company

      this.confirmDialogDeleteLoading = true

      this.deleteCompanyLocation({
        company_uuid,
        company_location_uuid: companyLocation.company_location_uuid,
      })
        .then(() => {
          this.confirmDialogDeleteLoading = false
          this.confirmDialogDelete = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'ลบข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$emit('formActionCompleted', this.formAction)
        })
        .catch((error) => {
          this.confirmDialogDeleteLoading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.$store.state.loading = true

        const timezoneName = tzlookup(
          this.companyLocation.latitude.toString(),
          this.companyLocation.longitude.toString()
        )

        const offset = this.getOffsetStr(timezoneName)

        const newLocation = {
          company_location_code: this.companyLocation.company_location_code,
          title_th: this.companyLocation.title_th,
          title_en: this.companyLocation.title_en,
          location_type_code:
            this.companyLocation.location_type?.location_type_code,
          latitude: this.companyLocation.latitude.toString(),
          longitude: this.companyLocation.longitude.toString(),
          radius_meter: parseInt(this.companyLocation.radius_meter, 10),
          timezone: offset,
        }

        const { company_uuid } = this.$store.state.authentication.company

        this.addCompanyLocation({
          company_uuid,
          data: newLocation,
        })
          .then(() => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'success',
              timeout: 2000,
              message: 'เพิ่มข้อมูลสำเร็จ',
            }

            this.$store.commit('SET_SNACKBAR', snackbar)

            this.$emit('formActionCompleted', this.formAction)
            this.$store.commit('googleMap/SET_MARKERS', [])
          })
          .catch((error) => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      }
    },
    onSave() {
      if (this.$refs.form.validate()) {
        this.$store.state.loading = true

        const timezoneName = tzlookup(
          this.companyLocation.latitude.toString(),
          this.companyLocation.longitude.toString()
        )

        const offset = this.getOffsetStr(timezoneName)

        const locationUpdate = {
          company_location_code: this.companyLocation.company_location_code,
          title_th: this.companyLocation.title_th,
          title_en: this.companyLocation.title_en,
          location_type_code:
            this.companyLocation.location_type?.location_type_code,
          latitude: this.companyLocation.latitude.toString(),
          longitude: this.companyLocation.longitude.toString(),
          radius_meter: parseInt(this.companyLocation.radius_meter, 10),
          timezone: offset,
        }

        const { company_uuid } = this.$store.state.authentication.company

        this.editCompanyLocation({
          company_uuid,
          company_location_uuid: this.companyLocation.company_location_uuid,
          data: locationUpdate,
        })
          .then(() => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'success',
              timeout: 2000,
              message: 'แก้ไขข้อมูลสำเร็จ',
            }

            this.$store.commit('SET_SNACKBAR', snackbar)

            this.$emit('formActionCompleted', this.formAction)
            this.$store.commit('googleMap/SET_MARKERS', [])
          })
          .catch((error) => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      }
    },
    onClose() {
      if (this.isCompanyLocationDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.$emit('formActionCompleted', this.formAction)
        this.$refs.form.resetValidation()
        this.$store.commit('googleMap/SET_MARKERS', [])
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false

      this.$emit('formActionCompleted', this.formAction)
      this.$refs.form.resetValidation()
      this.$store.commit('googleMap/SET_MARKERS', [])
    },
    onReset() {
      if (this.formAction === 'add' || this.formAction === '') {
        this.$refs.form.resetValidation()
        this.$store.commit('googleMap/SET_MARKERS', [])
      } else {
        this.$emit('onReset', this.formAction)
      }
    },
  },
}
</script>
